<div class="user-group-rule">
  <p class="rule-description">
    Enable the feature for specific user groups. The feature will be enabled for users who belong to these groups.
  </p>

  <div class="group-input-container">
    <label for="new-user-group">Add User Group:</label>
    <div class="input-group">
      <input
        type="text"
        id="new-user-group"
        [formControl]="newUserGroupControl"
        placeholder="Enter user group"
        (keydown.enter)="onInputKeydown($event)"
      />
      <button
        id="e2e-add-user"
        mat-flat-button
        color="primary"
        type="button"
        class="fx--ml-sm"
        (click)="addUserGroup()"
      >
        Add
      </button>
    </div>
    <div *ngIf="error" class="error-message">{{ error }}</div>
  </div>

  <div class="groups-container" *ngIf="userGroups.length > 0">
    <div class="groups-header">
      <h4>Target User Groups ({{ userGroups.length }})</h4>
      <button mat-button color="primary" type="button" (click)="clearUserGroups()">Clear All</button>
    </div>

    <ul class="groups-list">
      <li *ngFor="let group of userGroups; let i = index" class="group-item">
        <span class="group-name">{{ group }}</span>
        <button mat-button color="primary" type="button" (click)="removeUserGroup(i)" aria-label="Remove">×</button>
      </li>
    </ul>
  </div>

  <div class="empty-state" *ngIf="userGroups.length === 0">
    <p>No user groups added. This feature will not be enabled for any users based on group membership.</p>
  </div>
</div>
